import { defineStore } from "pinia";
import { entityStoreFactory } from "@/stores/factory/entity-store-factory";
import { MateTraitMedia } from "@/types/entity";
import { cursorPagerStoreFactory } from "@/stores/factory/list-store-factory";
import api from "@/modules/api";
import { ref } from "vue";

const cursorEncoder = (
  entity: MateTraitMedia<any>,
  pointsToNextItems: boolean
) => {
  return btoa(
    JSON.stringify({
      id: entity.id,
      _pointsToNextItems: pointsToNextItems,
    })
  );
};
const PAGE_SIZE = 10;

export const useMateTraitMedia = defineStore("mateTraitMedia", () => {
  // state
  const entityState = entityStoreFactory<MateTraitMedia, "id">("id");
  const { updateMap, getEntity, deleteItem } = entityState;
  const mateSessionId = ref<number | null>(null);
  const {
    state,
    dataList,
    fetchNewerList,
    fetchOlderList,
    initListIfAbsent,
    resetState,
  } = cursorPagerStoreFactory({
    entityStore: entityState,
    fetch: async (cursor?: string) => {
      const res = await api.readMateTraitMediaPage({
        filter: { mateSessionId: mateSessionId.value },
        pagination: { perPage: PAGE_SIZE },
        sort: { field: "id", order: "desc" },
        cursor,
      });
      updateMap(res.page.data);
      return res.page.data;
    },
    cursorEncoder,
  });

  // methods
  const changeMateSessionId = (id: number | null) => {
    if (id === mateSessionId.value) return;
    mateSessionId.value = id;
    resetState();
  };

  return {
    mateSessionId,
    state,
    dataList,
    fetchNewerList,
    fetchOlderList,
    initListIfAbsent,
    resetState,
    changeMateSessionId,
    updateMap,
    getEntity,
    deleteItem,
  };
});
